<div class="drw-container">
  <div class="drw-header">
    <span class="drw-title">Refund Authorization</span>
    <button (click)="close()" mat-icon-button [disabled]="isSubmitting">
      <mat-icon class="drw-close" viewBox="0 0 24 24" fill="none">close</mat-icon>
    </button>
  </div>

  <div class="drw-content">
    <div class="drw-sub-content">
      <span class="drw-title">Authorization Information</span>

      <div class="authorization-info">
        <p>Authorization ID: <span>{{ data.authorization.id }}</span></p>
        <p>Total Amount: <span>{{ data.authorization.total_amount | currency }}</span></p>
        <p>Captured Amount: <span>{{ data.authorization.captured_amount | currency }}</span></p>
      </div>
    </div>

    <div class="drw-sub-content">
      <span class="drw-title">Refund Information</span>

      <form [formGroup]="refundForm" class="refund-form">
        <!-- Transaction Amount -->
        <!-- <label for="amount">Transaction Amount</label>
        <mat-form-field appearance="fill" class="full-width">
          <span matPrefix>&nbsp;$</span>
          <input matInput formControlName="amount" id="amount" placeholder="Amount" type="text" mask="separator.2" [thousandSeparator]="','">
          <mat-error *ngIf="refundForm.get('amount')?.hasError('required')">
            Transaction amount is required
          </mat-error>
          <mat-error *ngIf="refundForm.get('amount')?.hasError('min')">
            Amount must be at least $0.01
          </mat-error>
          <mat-error *ngIf="refundForm.get('amount')?.hasError('max')">
            Amount cannot exceed captured amount of {{ data.authorization.captured_amount | currency }}
          </mat-error>
          <mat-error *ngIf="refundForm.get('amount')?.hasError('pattern')">
            Please enter a valid amount (up to 2 decimal places)
          </mat-error>
        </mat-form-field> -->

        <!-- Memo -->
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Memo</mat-label>
          <textarea matInput formControlName="memo" placeholder="Optional memo" rows="3"></textarea>
        </mat-form-field>
      </form>
    </div>
  </div>

  <div class="drw-footer">
    <button class="dialog-submit" mat-flat-button color="accent" [disabled]="refundForm.invalid || isSubmitting"
      (click)="submit()">
      @if (isSubmitting) {
        <mat-spinner [diameter]="20" color="accent"></mat-spinner>
      }
      @if (!isSubmitting) {
        <span>Refund Authorization</span>
      }
    </button>
  </div>
</div>